import React from 'react'
import Summary from './Summary'
import OrdersPreview from './OrdersPreview'
import OrdersCharts from '../orders/OrdersCharts'

function DashOverView() {
    return (
        <div className='space-y-6'>
            <h1 className="text-2xl font-bold text-gray-800">Dashboard Overview</h1>
            <div className='space-y-6'>
                <Summary />
                <OrdersPreview/>
                <OrdersCharts/>
            </div>
        </div>
    )
}

export default DashOverView